/**
 * CategoryIconBadge — 2026-08-19 (v4: original cartoon persona avatars).
 *
 * v1 was a hologram badge (ported from companion-console.html) — looked
 * like a fake rotating 2D card. v2 replaced it outright with a flat icon,
 * which lost the "avatar" ask entirely. v3 tried real-3D snapshots of one
 * CC0 rig recolored/rotated per variant — closer, but "everyone has the
 * same model" (it was, just tinted differently).
 *
 * v4: each persona gets a genuinely distinct hand-drawn cartoon avatar
 * (see PersonaAvatar.tsx) wearing a headset + mic — the actual ask. Pure
 * original SVG, so no external asset/licensing question and no async
 * generation step.
 */
import React from 'react';
import PersonaAvatar from './PersonaAvatar';

const HUE_COLORS = ['#B8752A', '#2E8B84', '#B0526A', '#5C8A3E', '#4F6488', '#6E5A96'];

export const hueColorForIndex = (i: number): string => HUE_COLORS[i % HUE_COLORS.length];

const CategoryIconBadge: React.FC<{
  color: string;
  variant?: number;
  live?: boolean;
  size?: number;
}> = ({ color, variant = 0, live = false, size = 44 }) => (
  <div className="relative flex-none" style={{ width: size, height: size }}>
    <div className="h-full w-full overflow-hidden rounded-full shadow-sm bg-muted">
      <PersonaAvatar variant={variant} accent={color} />
    </div>
    {live && (
      <span className="absolute -right-0.5 -top-0.5 block" style={{ width: size * 0.3, height: size * 0.3 }}>
        <span className="absolute inset-0 animate-ping rounded-full bg-amber-400 opacity-75" />
        <span className="absolute inset-0 rounded-full border-2 border-background bg-amber-400" />
      </span>
    )}
  </div>
);

export default CategoryIconBadge;
